module.exports = __webpack_public_path__ + "img/check-mark.c95785be.png";